import { createState } from 'shared'

export type SmartContract = {
	projectName: string
	owner: {
		id: string
		email: string
		firstName: string
		lastName: string
	}
	isCollaborator: boolean
	active: boolean
	createdAt: string
	description: string
	id: string
	name: string
	projectId: string
	status: string
	version: string
	webIdeUrl: string
	isWorkspaceReady: boolean
	color: {
		default: string
		hover: string
	}
}

const SmartContractsStateContainer = createState<SmartContract[]>([])
export const smartContractsState = SmartContractsStateContainer.state

export const setSmartContracts = (smartContracts: SmartContract[]) => {
	SmartContractsStateContainer.updateState(() => smartContracts)
}

export const addNewSmartContract = (smartContract: SmartContract) => {
	SmartContractsStateContainer.updateState(prevState => [
		smartContract,
		...prevState
	])
}

export const setSmartContractWorkspaceReadyState = (
	smartContractId: string,
	isWorkspaceReady: boolean
) => {
	SmartContractsStateContainer.updateState(oldSmartContracts =>
		oldSmartContracts.map(smContract => {
			if (smContract.id === smartContractId) {
				return {
					...smContract,
					isWorkspaceReady
				}
			}

			return smContract
		})
	)
}
